import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63c6f2e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-filter px-7 py-5 w-100" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Compétences", -1))
const _hoisted_4 = { class: "rounded-sm" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Statut", -1))
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "filter-types" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Sélectionner type", -1))
const _hoisted_10 = { class: "d-flex gap-2 justify-content-center p-1 rounded-sm" }
const _hoisted_11 = ["name", "value", "id"]
const _hoisted_12 = ["for", "id"]
const _hoisted_13 = { class: "d-block" }
const _hoisted_14 = { class: "d-block fs-6" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Utilisateur", -1))
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Projet", -1))
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Date", -1))
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "d-flex justify-content-center gap-2 align-items-end" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-md btn-primary",
  "data-kt-menu-dismiss": "true"
}, " Appliquer ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("form", {
    class: "container-filter rounded-lg mt-2 d-flex",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitFilterData()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.data.skills,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.skills) = $event)),
            multiple: "",
            filterable: "",
            "allow-create": "",
            "default-first-option": "",
            placeholder: "Choose skills for your target"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsSkills, (option, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: option.label,
                  value: option.value,
                  class: "fw-bold text-gray-800",
                  key: index
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.data.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.status) = $event)),
            multiple: "",
            "collapse-tags": "",
            placeholder: "To Do",
            name: "todo",
            as: "select"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsStatut, (option, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: option.label,
                  value: option.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsTypes, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "platform-select",
              key: index
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "btn-check",
                name: option.name,
                value: option.value,
                id: option.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.type) = $event))
              }, null, 8, _hoisted_11), [
                [_vModelCheckbox, _ctx.data.type]
              ]),
              _createElementVNode("label", {
                class: "btn btn-outline btn-outline-primary d-flex align-items-center lh-0 px-4 py-5 border-0 filter-types-label",
                for: option.value,
                id: option.value
              }, [
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(option.name), 1)
                ])
              ], 8, _hoisted_12)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.data.users,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.users) = $event)),
            multiple: "",
            "collapse-tags": "",
            placeholder: "Select User",
            name: "SelectUser",
            as: "select"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsUsers, (option, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: option.name,
                  value: option.name
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.data.projects,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.projects) = $event)),
            multiple: "",
            "collapse-tags": "",
            placeholder: "Select project",
            name: "SelectProject",
            as: "select"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsProjects, (option, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: option.name,
                  value: option.name
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.data.date,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.date) = $event)),
            type: "date",
            placeholder: "Pick a day"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("button", {
          type: "reset",
          class: "btn btn-outline-primary",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.restForm && _ctx.restForm(...args)))
        }, " Réinitialiser ")
      ])
    ])
  ], 32))
}